(() => {
  window.currencyPopupController?.destroy();

  const controller = new AbortController();
  const options = { signal: controller.signal };
  const desktop = window.matchMedia('(min-width: 990px)');
  const priorityCodes = ['GBP', 'USD', 'EUR'];
  const regionDefinitions = [
    ['Europe', 'AD AL AT AX BA BE BG BY CH CZ DE DK EE ES FI FO FR GB GG GI GR HR HU IE IM IS IT JE LI LT LU LV MC MD ME MK MT NL NO PL PT RO RS RU SE SI SJ SK SM UA VA XK'],
    ['Americas', 'AG AI AR AW BB BL BM BO BQ BR BS BZ CA CL CO CR CU CW DM DO EC FK GD GF GL GP GT GY HN HT JM KN KY LC MF MQ MS MX NI PA PE PM PR PY SR SV SX TC TT US UY VC VE VG VI'],
    ['Asia', 'AE AF AM AZ BD BH BN BT CN CY GE HK ID IL IN IO IQ IR JO JP KG KH KP KR KW KZ LA LB LK MM MN MO MV MY NP OM PH PK PS QA SA SG SY TH TJ TL TM TR TW UZ VN YE'],
    ['Africa', 'AO BF BI BJ BW CD CF CG CI CM CV DJ DZ EG EH ER ET GA GH GM GN GQ GW KE KM LR LS LY MA MG ML MR MU MW MZ NA NE NG RE RW SC SD SH SL SN SO SS ST SZ TD TG TN TZ UG YT ZA ZM ZW'],
    ['Oceania', 'AS AU CC CK CX FJ FM GU KI MH MP NC NF NR NU NZ PF PG PN PW SB TK TO TV UM VU WF WS'],
    ['Antarctica', 'AQ BV GS HM TF']
  ];
  const regionsByCountry = new Map();
  const footers = new Set();
  let mobileView = null;

  regionDefinitions.forEach(([region, codes]) => {
    codes.split(' ').forEach(code => regionsByCountry.set(code, region));
  });

  function currencyName(code) {
    try {
      const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'currency' });
      const name = names.of(code);
      return name && name !== code ? `${code} / ${name}` : code;
    } catch {
      return code;
    }
  }

  function populateFlags(panel) {
    panel.querySelectorAll('[data-destination-flag]').forEach(flag => {
      const code = (flag.dataset.destinationFlag || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(code)) return;
      flag.textContent = String.fromCodePoint(...Array.from(code, letter => 127397 + letter.charCodeAt(0)));
    });
  }

  function chevron() {
    const mark = document.createElement('span');
    mark.className = 'destination-chevron';
    mark.setAttribute('aria-hidden', 'true');
    return mark;
  }

  function sortCountries(buttons, currency) {
    const preferred = currency === 'GBP' ? 'GB' : currency === 'USD' ? 'US' : null;
    return [...buttons].sort((a, b) => {
      if (a.dataset.countryCode === preferred) return -1;
      if (b.dataset.countryCode === preferred) return 1;
      return a.dataset.countryName.localeCompare(b.dataset.countryName, document.documentElement.lang || 'en');
    });
  }

  function countryList(buttons) {
    const list = document.createElement('ul');
    list.className = 'destination-list';
    list.setAttribute('role', 'list');
    buttons.forEach(button => {
      const row = document.createElement('li');
      row.setAttribute('data-destination-country', '');
      row.dataset.search = [
        button.dataset.countryCode,
        button.dataset.countryName,
        button.dataset.currencyCode,
        button.dataset.currencySymbol,
        currencyName(button.dataset.currencyCode)
      ].join(' ').toLowerCase();
      row.append(button);
      list.append(row);
    });
    return list;
  }

  function disclosure(label, content, symbol = '') {
    const group = document.createElement('details');
    group.className = 'destination-group';
    group.setAttribute('data-destination-group', '');
    const summary = document.createElement('summary');
    summary.className = 'destination-heading';
    if (symbol) {
      const icon = document.createElement('span');
      icon.className = 'destination-currency-symbol';
      icon.textContent = symbol;
      summary.append(icon);
    }
    const title = document.createElement('span');
    title.className = 'destination-copy';
    title.textContent = label;
    summary.append(title, chevron());
    group.append(summary, content);
    return group;
  }

  function build(panel) {
    if (panel.dataset.destinationBuilt === 'true') return;
    const source = panel.querySelector('[data-destination-source]');
    const results = panel.querySelector('[data-destination-results]');
    if (!source?.content || !results) throw new Error('Destination selector: source template or results container missing.');

    const pinned = new Map();
    const regions = new Map();
    source.content.querySelectorAll('button').forEach(original => {
      const button = original.cloneNode(true);
      const code = button.dataset.currencyCode;
      if (priorityCodes.includes(code)) {
        if (!pinned.has(code)) pinned.set(code, []);
        pinned.get(code).push(button);
      } else {
        const region = regionsByCountry.get(button.dataset.countryCode) || 'Other destinations';
        if (!regions.has(region)) regions.set(region, []);
        regions.get(region).push(button);
      }
    });

   const fragment = document.createDocumentFragment();

const popular = panel.querySelector(
  '[data-destination-popular]'
);

const popularItems = panel.querySelector(
  '[data-destination-popular-items]'
);

popularItems.replaceChildren();
popular.hidden = pinned.size === 0;

priorityCodes.forEach(code => {
  if (!pinned.has(code)) return;

  const buttons = sortCountries(pinned.get(code), code);
  const list = countryList(buttons);

  popularItems.append(
    buttons.length > 1
      ? disclosure(
          currencyName(code),
          list,
          buttons[0].dataset.currencySymbol
        )
      : list
  );
});

    [...regionDefinitions.map(([name]) => name), 'Other destinations'].forEach(name => {
      if (!regions.has(name)) return;
      fragment.append(disclosure(name, countryList(sortCountries(regions.get(name)))));
    });
    results.replaceChildren(fragment);
    populateFlags(panel);
    source.remove();
    panel.dataset.destinationBuilt = 'true';
  }

  function filter(panel, query) {
    let count = 0;
    const groups = panel.querySelectorAll('[data-destination-group]');
    groups.forEach(group => {
      if (query && group.dataset.beforeSearch === undefined) group.dataset.beforeSearch = String(group.open);
    });
    panel.querySelectorAll('[data-destination-country]').forEach(row => {
      row.hidden = !row.dataset.search.includes(query);
      if (!row.hidden) count += 1;
    });
    groups.forEach(group => {
      const matches = Array.from(group.querySelectorAll('[data-destination-country]')).some(row => !row.hidden);
      group.hidden = !matches;
      if (query) group.open = matches;
      else if (group.dataset.beforeSearch !== undefined) {
        group.open = group.dataset.beforeSearch === 'true';
        delete group.dataset.beforeSearch;
      }
    });
    const divider = panel.querySelector('[data-destination-divider]');
    if (divider) divider.hidden = Boolean(query);
    panel.querySelector('[data-destination-empty]').hidden = count > 0;
  }

  function resetSearch(panel) {
    const input = panel.querySelector('[data-destination-search]');
    if (input) input.value = '';
    filter(panel, '');
  }

  function restoreMobile(focus = false) {
    const record = mobileView;
    if (!record) return;
    mobileView = null;
    record.observer.disconnect();
    record.panel.hidden = true;
    record.panel.classList.remove('destination-mobile-view');
    record.placeholder.replaceWith(record.panel);
    record.navigation.hidden = record.wasHidden;
    record.trigger.setAttribute('aria-expanded', 'false');
    record.inner.classList.remove('destination-view-open');
    if (focus && record.details.open && record.trigger.isConnected) {
      if (typeof trapFocus === 'function') trapFocus(record.menu, record.trigger);
      else record.trigger.focus({ preventScroll: true });
      record.navigation.scrollTop = record.scrollTop;
      window.ContentEntrance?.enter(
        record.navigation.querySelector('.menu-drawer__navigation')
      );
    }
  }

  function openMobile(selector, trigger, panel) {
    const drawer = selector.closest('header-drawer');
    const details = drawer?.querySelector(':scope > details');
    const menu = drawer?.querySelector('.menu-drawer');
    const inner = menu?.querySelector('.menu-drawer__inner-container');
    const navigation = inner?.querySelector('.menu-drawer__navigation-container');
    if (!details?.open || !inner || !navigation) throw new Error('Destination selector: expected open header drawer structure missing.');
    restoreMobile();
    build(panel);
    resetSearch(panel);
    const placeholder = document.createComment('Destination selector panel');
    panel.before(placeholder);
    const record = {
      selector, trigger, panel, details, menu, inner, navigation, placeholder,
      wasHidden: navigation.hidden,
      scrollTop: navigation.scrollTop,
      observer: new MutationObserver(() => {
        if (!details.open || !details.classList.contains('menu-opening')) restoreMobile();
      })
    };
    mobileView = record;
    panel.classList.add('destination-mobile-view');
    inner.append(panel);
    navigation.hidden = true;
    inner.classList.add('destination-view-open');
    panel.hidden = false;
    panel.scrollTop = 0;
    trigger.setAttribute('aria-expanded', 'true');
    const back = panel.querySelector('[data-destination-back]');
    if (typeof trapFocus === 'function') trapFocus(menu, back);
    else back?.focus({ preventScroll: true });
    record.observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    window.ContentEntrance?.enter(
      panel.querySelector('.destination-content')
    );
  }

  function closeFooters(except = null) {
    footers.forEach(selector => {
      if (selector === except) return;
      selector.querySelector('[data-destination-panel]').hidden = true;
      selector.querySelector('[data-destination-trigger]').setAttribute('aria-expanded', 'false');
      footers.delete(selector);
    });
  }

  function onClick(event) {
    if (!(event.target instanceof Element)) return;
    const back = event.target.closest('[data-destination-back]');
    if (back && mobileView?.panel.contains(back)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      restoreMobile(true);
      return;
    }
    const trigger = event.target.closest('[data-destination-trigger]');
    if (!trigger) {
      if (!event.target.closest('[data-destination-mode="footer"]')) closeFooters();
      return;
    }
    const selector = trigger.closest('[data-destination-selector]');
    const panel = selector.querySelector('[data-destination-panel]');
    const mode = selector.dataset.destinationMode;
    try {
      if (mode === 'desktop') {
        // Populate before the existing header handler opens its normal dropdown.
        if (desktop.matches) {
          build(panel);
          resetSearch(panel);
        }
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (mode === 'mobile') {
        if (!desktop.matches) openMobile(selector, trigger, panel);
      } else {
        build(panel);
        const open = panel.hidden;
        closeFooters(selector);
        if (open) resetSearch(panel);
        panel.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
        if (open) footers.add(selector);
        else footers.delete(selector);
      }
    } catch (error) {
      console.error(error);
      if (mode !== 'desktop') restoreMobile();
    }
  }

  document.addEventListener('click', onClick, { capture: true, signal: controller.signal });
  document.addEventListener('input', event => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-destination-search]')) return;
    filter(event.target.closest('[data-destination-panel]'), event.target.value.trim().toLowerCase());
  }, options);
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element)) return;
    if (event.key === 'Enter' && event.target.matches('[data-destination-search]')) event.preventDefault();
    if (event.key === 'Escape') {
      const footer = event.target.closest('[data-destination-mode="footer"]');
      if (footer && footers.has(footer)) {
        event.preventDefault();
        closeFooters();
        footer.querySelector('[data-destination-trigger]').focus({ preventScroll: true });
      }
    }
  }, options);
  desktop.addEventListener('change', () => restoreMobile(), options);
  document.addEventListener('shopify:section:unload', event => {
    if (!(event.target instanceof Element)) return;
    if (mobileView && event.target.contains(mobileView.selector)) restoreMobile();
    footers.forEach(selector => {
      if (event.target.contains(selector)) {
        selector.querySelector('[data-destination-panel]').hidden = true;
        selector.querySelector('[data-destination-trigger]').setAttribute('aria-expanded', 'false');
        footers.delete(selector);
      }
    });
  }, options);

  window.currencyPopupController = {
    destroy() {
      restoreMobile();
      closeFooters();
      controller.abort();
    }
  };
})();